module.exports = __webpack_public_path__ + "img/yacht-6.7e6de29d.jpg";